var index =
webpackJsonp_name_([18,50],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(49);
	__webpack_require__(92);
	__webpack_require__(525);
	__webpack_require__(528);
	__webpack_require__(530);
	__webpack_require__(128);
	__webpack_require__(532);
	__webpack_require__(535);
	__webpack_require__(102);
	__webpack_require__(538);
	__webpack_require__(199);
	__webpack_require__(539);
	__webpack_require__(542);
	__webpack_require__(544);
	__webpack_require__(547);
	__webpack_require__(549);
	__webpack_require__(94);
	__webpack_require__(97);
	__webpack_require__(552);
	__webpack_require__(150);
	__webpack_require__(193);
	__webpack_require__(106);
	__webpack_require__(105);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	var debounce = __webpack_require__(53);
	__webpack_require__(54);
	
	var size = __webpack_require__(56);
	
	jQuery(function ($) {
	    function setSlickBenefits() {
	        $('.js-slick-benefits').each(function () {
	            var $benefitsSlider = $(this);
	
	            if (!$benefitsSlider.hasClass('slick-initialized')) {
	                $benefitsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	                    slidesToShow: 4,
	                    adaptiveHeight: false,
	                    responsive: [{
	                        breakpoint: size.desktop,
	                        settings: { slidesToShow: 2 }
	                    }, {
	                        breakpoint: size.tablet,
	                        settings: { slidesToShow: 1 }
	                    }]
	                }));
	            }
	        });
	    }
	    setSlickBenefits();
	
	    debounce.setResizeDebounce(setSlickBenefits);
	});

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	__webpack_require__(95);
	
	var size = __webpack_require__(56);
	
	jQuery(function () {
	    $('.js-slick-reviews').each(function () {
	        var $reviewsSlider = $(this);
	
	        $reviewsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            adaptiveHeight: false,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: {
	                    slidesToShow: 2
	                }
	            }, {
	                breakpoint: size.tablet,
	                settings: {
	                    slidesToShow: 1
	                }
	            }]
	        }));
	    });
	});

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	__webpack_require__(106);
	
	var size = __webpack_require__(56);
	
	jQuery(function () {
	    $('.js-slick-promos').each(function () {
	        var $promosSlider = $(this);
	
	        $promosSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 5,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: { slidesToShow: 4 }
	            }, {
	                breakpoint: size.tabletBig,
	                settings: { slidesToShow: 3 }
	            }, {
	                breakpoint: size.tablet,
	                settings: { slidesToShow: 2 }
	            }, {
	                breakpoint: size.mobileBig,
	                settings: { slidesToShow: 1 }
	            }]
	        }));
	    });
	});

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(116)['default'];
	
	var _trackerEvents = __webpack_require__(129);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	__webpack_require__(144);
	
	var event = new _trackerEvents2['default']();
	event.onShowProductCard();
	
	$('#toogle_open').click(function () {
	    $('.li_toogle').css('display', 'list-item');
	    $('.li_toogle').addClass('li_toogle_close');
	    $('#toogle_open').css('display', 'none');
	    $('#toogle_close').css('display', 'block');
	});
	$('#toogle_close').click(function () {
	    $('.li_toogle').css('display', 'none');
	    $('.li_toogle').removeClass('li_toogle_close');
	    $('#toogle_open').css('display', 'block');
	    $('#toogle_close').css('display', 'none');
	});

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	__webpack_require__(526);
	
	jQuery(function ($) {
	    function fwClearAnimationClasses(e) {
	        $(e.target).removeClass('fullwidth-slider__item--animated ' + 'fullwidth-slider__item--animated-out ' + 'fullwidth-slider__item--animated-in ' + 'fullwidth-slider__item--fadeOutRight ' + 'fullwidth-slider__item--fadeInLeft');
	    }
	
	    $('.js-slick-fullwidth-slider').each(function () {
	        var $fwSlider = $(this);
	
	        $fwSlider.slick($.extend({}, slickDefaults.params, {
	            slidesToShow: 1,
	            centerMode: true,
	            centerPadding: 0,
	            dots: true,
	            fade: true,
	            speed: 300,
	            zIndex: 300,
	            autoplay: true
	        }));
	
	        $fwSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	            var $current = slick.$slides.eq(currentSlide);
	            var $next = slick.$slides.eq(nextSlide);
	
	            $current.addClass('fullwidth-slider__item--animated fws--animated-out').addClass('fullwidth-slider__item--fadeOutRight').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', fwClearAnimationClasses);
	
	            $next.addClass('fullwidth-slider__item--animated fullwidth-slider__item--animated-in').addClass('fullwidth-slider__item--fadeInLeft').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', fwClearAnimationClasses);
	        });
	    });
	});

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	var debounce = __webpack_require__(53);
	__webpack_require__(533);
	
	var size = __webpack_require__(56);
	
	jQuery(function ($) {
	    function setProductsShowcaseSlider() {
	        var defaultOptions = $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: { slidesToShow: 2 }
	            }, {
	                breakpoint: size.tabletBig,
	                settings: { slidesToShow: 1 }
	            }]
	        });
	
	        $('.js-products-showcase-slider').each(function () {
	            var $psSlider = $(this);
	
	            if (!$psSlider.hasClass('slick-initialized')) {
	                $psSlider.slick($.extend({}, defaultOptions, {
	                    slidesToShow: 3,
	                    responsive: [{
	                        breakpoint: size.desktop,
	                        settings: { slidesToShow: 2 }
	                    }, {
	                        breakpoint: size.tabletBig,
	                        settings: { slidesToShow: 1, dots: false }
	                    }, {
	                        breakpoint: size.tablet,
	                        settings: { slidesToShow: 2, dots: true }
	                    }, {
	                        breakpoint: size.mobileBig,
	                        settings: { slidesToShow: 1, dots: true }
	                    }]
	                }));
	            }
	        });
	
	        $('.js-products-slider-full').each(function () {
	            var $psSlider = $(this);
	
	            if (window.innerWidth < size.tablet) {
	                if ($psSlider.hasClass('slick-initialized')) $psSlider.slick('unslick');
	            } else {
	                if (!$psSlider.hasClass('slick-initialized')) {
	                    $psSlider.slick($.extend({}, defaultOptions, {
	                        slidesToShow: 5,
	                        responsive: [{
	                            breakpoint: size.desktop,
	                            settings: { slidesToShow: 4 }
	                        }, {
	                            breakpoint: size.tabletBig,
	                            settings: { slidesToShow: 3 }
	                        }]
	                    }));
	                }
	            }
	        });
	
	        $('.js-products-slider-middle').each(function () {
	            var $psSlider = $(this);
	
	            if (window.innerWidth < size.tablet) {
	                if ($psSlider.hasClass('slick-initialized')) $psSlider.slick('unslick');
	            } else {
	                if (!$psSlider.hasClass('slick-initialized')) {
	                    $psSlider.slick($.extend({}, defaultOptions, {
	                        slidesToShow: 3,
	                        responsive: [{
	                            breakpoint: size.desktop,
	                            settings: { slidesToShow: 4 }
	                        }, {
	                            breakpoint: size.tabletBig,
	                            settings: { slidesToShow: 3 }
	                        }]
	                    }));
	                }
	            }
	        });
	    }
	    setProductsShowcaseSlider();
	    debounce.setResizeDebounce(setProductsShowcaseSlider);
	});

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	var size = __webpack_require__(56);
	__webpack_require__(536);
	
	jQuery(function ($) {
	    var defaultOptions = $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	        slidesToShow: 3,
	        responsive: [{
	            breakpoint: size.desktop,
	            settings: { slidesToShow: 2 }
	        }, {
	            breakpoint: size.tabletBig,
	            settings: { slidesToShow: 1 }
	        }]
	    });
	
	    $('.js-slider-sections-mobile:not(#sectionsSlider)').each(function () {
	        var $psSlider = $(this);
	
	        $psSlider.slick($.extend({}, defaultOptions, {
	            slidesToShow: 1,
	            dots: true,
	            arrows: true,
	            responsive: []
	        }));
	    });
	
	    var $slider = $('#sectionsSlider');
	    $slider.slick($.extend({}, defaultOptions, {
	        slidesToShow: 4,
	        dots: true,
	        arrows: false,
	        responsive: [{
	            breakpoint: 670,
	            settings: {
	                slidesToShow: 3
	            }
	        }, {
	            breakpoint: 520,
	            settings: {
	                slidesToShow: 2
	            }
	        }]
	    }));
	});

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	
	var size = __webpack_require__(56);
	
	jQuery(function () {
	    var $container = $('.js-slick-brands');
	    var settings = $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	        slidesToShow: 5,
	        responsive: [{
	            breakpoint: size.desktop,
	            settings: { slidesToShow: 4 }
	        }, {
	            breakpoint: size.tabletBig,
	            settings: { slidesToShow: 3 }
	        }, {
	            breakpoint: size.tablet,
	            settings: { slidesToShow: 2 }
	        }, {
	            breakpoint: size.mobileBig,
	            settings: 'unslick'
	        }]
	    });
	    runSlick($container, settings);
	    $(window).resize(function () {
	        var width = window.innerWidth || document.body.clientWidth;
	        if (!$container.hasClass('slick-initialized') && width > size.mobileBig) {
	            runSlick($container, settings);
	        }
	    });
	});
	
	function runSlick($sliderContainer, settings) {
	    $sliderContainer.each(function () {
	        $(this).slick(settings);
	    });
	}

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debounce = __webpack_require__(53);
	__webpack_require__(540);
	
	var size = __webpack_require__(56);
	
	jQuery(function () {
	    function tileLayoutChanged($this, oldWidth, newWidth) {
	        oldWidth = parseInt(oldWidth);
	        newWidth = parseInt(newWidth);
	
	        var arEdges = [size.desktop, size.tabletBig, size.tablet];
	
	        var paddingCorrection = 0;
	
	        var $wrapper = $this.closest('.wrapper');
	        paddingCorrection += parseInt($wrapper.css('padding-left'));
	        paddingCorrection += parseInt($wrapper.css('padding-right'));
	        paddingCorrection = parseInt(paddingCorrection);
	        for (var key in arEdges) {
	            var cur = arEdges[key];
	            cur = parseInt(cur);
	
	            var diffOld = oldWidth + paddingCorrection - cur;
	            var diffNew = newWidth + paddingCorrection - cur;
	
	            //если изменение ширины блока перешагнуло через одну из границ
	            if (Math.max(diffOld, diffNew) > 0 && Math.min(diffOld, diffNew) < 0) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function findTileWithNeededWIdth($tiles, index, leftSpace) {
	        var $return = 0;
	
	        $tiles.each(function (ind) {
	            if (ind <= index) return true;
	
	            var $cur = $(this);
	
	            if (!$cur.is(':visible')) return true;
	
	            if (leftSpace >= parseInt($cur.innerWidth())) {
	                $return = $cur;
	                return false;
	            }
	        });
	
	        return $return;
	    }
	
	    function reflowTiles() {
	        $('.js-tiles-container').each(function () {
	            var $this = $(this);
	            var $tiles = $this.find('.tiles_item');
	            var totalWidth = $this.width();
	
	            var oldWidth = $this.attr('old-width');
	            if (isNaN(oldWidth)) oldWidth = 0;
	
	            if (oldWidth == totalWidth) {
	                return true;
	            }
	
	            if (!tileLayoutChanged($this, oldWidth, totalWidth)) return true;
	
	            $this.attr('old-width', totalWidth);
	
	            var curLineWidth = 0;
	
	            $tiles.each(function () {
	                var $curTile = $(this);
	
	                if (!$curTile.is(':visible')) return true;
	
	                var curTileWidth = $curTile.innerWidth();
	
	                if (curLineWidth + curTileWidth <= totalWidth) {
	                    //влезает
	                    curLineWidth += curTileWidth;
	
	                    //новая строка
	                    if (curLineWidth == totalWidth) curLineWidth = 0;
	                } else {
	                    //не влезает
	                    var leftSpace = totalWidth - curTileWidth;
	                    var $tileToChange = findTileWithNeededWIdth($tiles, $tiles.index($curTile), leftSpace);
	
	                    if ($tileToChange == 0) return true;
	
	                    $tileToChange.insertBefore($curTile);
	                    return false;
	                }
	            });
	        });
	    }
	
	    reflowTiles();
	    debounce.setResizeDebounce(reflowTiles);
	});

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	var debounce = __webpack_require__(53);
	__webpack_require__(545);
	
	var size = __webpack_require__(56);
	
	jQuery(function () {
	    var $newsSlider = $('.js-slick-news-list');
	
	    function setNewsSlider() {
	        $newsSlider.each(function () {
	            var $this = $(this);
	            if (window.innerWidth >= size.mobileBig) {
	                if ($this.hasClass('slick-initialized')) $this.slick('unslick');
	            } else {
	                if (!$this.hasClass('slick-initialized')) {
	                    $this.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	                        slidesToShow: 1,
	                        dots: true
	                    }));
	                }
	            }
	        });
	    }
	
	    setNewsSlider();
	    debounce.setResizeDebounce(setNewsSlider);
	});

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(550);
	
	jQuery(function () {
	    $('.js-news-item-img').click(function (e) {
	        e.preventDefault();
	        var $newsItem = $(this).closest('.news-item');
	        var $newsItemLink = $newsItem.find('.news-item__link');
	
	        window.location = $newsItemLink.attr('href');
	    });
	});

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(116)['default'];
	
	var _googleCaptcha = __webpack_require__(441);
	
	var _googleCaptcha2 = _interopRequireDefault(_googleCaptcha);
	
	var _trackerTracker = __webpack_require__(138);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesPreloader = __webpack_require__(118);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	__webpack_require__(553);
	
	var captcha = undefined,
	    bxCaptchaSid = undefined;
	
	var recaptchaPrompt = {
	    recaptchaForm: {
	        html: $('.js-recaptcha-component').remove().html(),
	        submit: function submit(e) {
	            e.preventDefault();
	            var trackers = new _trackerTracker2['default']();
	            var $this = $('form.subscribe-form__form.js-subscribe-form');
	            var $errorBlock = $this.find('.subscribe-form__error');
	            var $emailInput = $this.find('input[type=email]');
	
	            window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
	            var currentCaptchaId = window.Recaptchafree.items[window.Recaptchafree.items.length - 1];
	            var recaptchaResponse = grecaptcha.getResponse(currentCaptchaId) || '';
	            var email = $this.find('.subscribe-form__input').val();
	            if (!recaptchaResponse) {
	                $('.captcha-field-subscribe .form__captcha-error').html('Необходимо выполнить captcha!' + '<br>').addClass('form__error-msg');
	                return;
	            } else {
	                (function () {
	                    var loader = new _modulesPreloader2['default']();
	                    loader.show();
	                    $.ajax({
	                        type: 'POST',
	                        url: '/ajax/action/subscribe_form/subscribe/',
	                        data: {
	                            email: email
	                        },
	                        success: function success(response) {
	                            loader.hide();
	                            if (response.message == 'ok') {
	                                $errorBlock.remove();
	                                $emailInput.removeClass('subscribe-form__input--error');
	
	                                var $successBlock = $this.closest('.subscribe-form').find('.subscribe-form__success');
	
	                                $successBlock.fadeIn(300);
	                                trackers.onSubscriptionDone();
	
	                                $('.form__captcha-success').html('Вы успешно подписаны!' + '<br>');
	                                $('.b-form-subscribe').remove();
	                            } else {
	                                $errorBlock.text(response.message);
	                                $emailInput.addClass('subscribe-form__input--error');
	                                $this.find('.subscribe-form__input-field').prepend($errorBlock);
	
	                                $('.captcha-field-subscribe .form__captcha-error').html(response.message + '<br>').addClass('form__error-msg');
	                            }
	                        },
	                        dataType: 'json'
	                    });
	                })();
	            }
	            e.preventDefault();
	        }
	    }
	};
	
	module.exports = recaptchaPrompt;
	
	jQuery(function ($) {
	    var $subscribeForm = $('.js-subscribe-form');
	
	    var trackers = new _trackerTracker2['default']();
	
	    $subscribeForm.attr('novalidate', true);
	
	    $subscribeForm.submit(function (e) {
	        e.preventDefault();
	        trackers.onSubscribe();
	        var $this = $(this);
	        var $errorBlock = $this.find('.subscribe-form__error');
	        if ($errorBlock.length == 0) $errorBlock = $('<div class="subscribe-form__error" />');
	        var $emailInput = $this.find('input[type=email]');
	        var emailPattern = /^([a-z0-9_.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
	        window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
	        $('.subscribe-form__content .form__captcha-error').removeClass('form__error-msg');
	        $('.subscribe-form__content .form__captcha-error').html(' ');
	        if (emailPattern.test($emailInput.val())) {
	            $errorBlock.text('');
	            $.prompt(recaptchaPrompt, {
	                initialState: 'recaptchaForm',
	                statechanging: function statechanging(e, from, to) {
	                    window.Recaptchafree.render();
	                }
	            });
	        } else {
	            $errorBlock.text('Указан неверный e-mail');
	            $emailInput.addClass('subscribe-form__input--error');
	            $this.find('.subscribe-form__input-field').prepend($errorBlock);
	        }
	    });
	});

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/index.009c100b0f36ec1f88c8.js